module.exports = __webpack_public_path__ + "img/gigastore-lp-sdk.6d457e47.png";